import { HttpInterceptorFn } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';

export const CORRELATION_HEADER = 'X-Correlation-Id';

export const correlationIdInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.has(CORRELATION_HEADER)) {
    return next(req);
  }
  return next(
    req.clone({
      setHeaders: {
        [CORRELATION_HEADER]: uuidv4(),
      },
    })
  );
};
